import * as apiClient from '../../common/ApiClient/ApiClient'

export const getContracts = () => {
    return apiClient.getContracts()
        .then(contracts => contracts)
        .catch(error => Promise.reject(error))
}

export const getContract = (contractId) => {
    return apiClient.getContract(contractId)
        .then(contract => contract)
        .catch(error => Promise.reject(error))
}

export const createContract = (contract) => {
    return apiClient.createContract(contract)
        .then(response => response)
        .catch(error => Promise.reject(error))
}

export const setContractAsCurrent = (contractId) => {
    return apiClient.setContractAsCurrent(contractId)
        .then(response => response)
        .catch(error => Promise.reject(error))
}


// WEBPACK FOOTER //
// ./src/components/Contracts/ContractsService.jsx